// useVerifications.ts
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";
import VerificationService, { VerificationFilters } from "@/integrations/service/verification.service";
import { VerificationDto } from "@/types/verification.types";

export const useVerifications = (filters?: VerificationFilters, enabled = true) => {
  return useQuery({
    queryKey: [...queryKeys.verifications, filters],
    queryFn: () => VerificationService.getAll(filters),
    enabled,
  });
};

export const useVerification = (id: number) => {
  return useQuery({
    queryKey: queryKeys.verification(id),
    queryFn: () => VerificationService.getById(id),
    enabled: !!id,
  });
};

export const useVerificationBySlug = (slug: string) => {
  return useQuery({
    queryKey: queryKeys.verificationSlug(slug),
    queryFn: () => VerificationService.getBySlug(slug),
    enabled: !!slug,
  });
};

export const useCreateVerification = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: VerificationService.create,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.verifications });
    },
  });
};

export const useUpdateVerification = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: any }) =>
      VerificationService.update(id, payload),
    onSuccess: (_, { id }) => {
      qc.invalidateQueries({ queryKey: queryKeys.verifications });
      qc.invalidateQueries({ queryKey: queryKeys.verification(id) });
    },
  });
};

export const useMesVerifications = (enabled = true) => {
  return useQuery({
    queryKey: ["mes-verifications"],
    queryFn: VerificationService.getMesVerifications,
    enabled,
  });
};

export const useValiderVerification = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: VerificationService.valider,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.verifications });
      qc.invalidateQueries({ queryKey: ["mes-verifications"] });
    },
  });
};

export const useRefuserVerification = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: VerificationService.refuser,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.verifications });
      qc.invalidateQueries({ queryKey: ["mes-verifications"] });
    },
  });
};

export const useDeleteVerification = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: VerificationService.delete,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.verifications });
    },
  });
};

// export function useVerifications() {
//   return useQuery<VerificationDto[]>({
//     queryKey:  ["verifications"],
//     queryFn:   VerificationService.getAll,
//     staleTime: 60_000,
//   });
// }
 
// /** Une vérification par son slug */
// export function useVerificationBySlug(slug: string) {
//   return useQuery<VerificationDto>({
//     queryKey: ["verification", slug],
//     queryFn:  () => VerificationService.getBySlug(slug),
//     enabled:  !!slug,
//     staleTime: 60_000,
//   });
// }
 
/** Une vérification par son id */
export function useVerificationById(id: number) {
  return useQuery<VerificationDto>({
    queryKey: ["verification", id],
    queryFn:  () => VerificationService.getById(id),
    enabled:  !!id,
    staleTime: 60_000,
  });
}
 